import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { promotions } from "@/data/catalog";
import { buildWhatsAppUrl } from "@/lib/site";

const Promociones = () => {
  const { t, lang } = useLang();

  return (
    <main data-testid="promotions-page" className="bg-cream text-ink">
      {/* HERO */}
      <section className="pt-40 pb-16 md:pt-48 md:pb-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 items-end">
          <div className="md:col-span-7">
            <p className="overline">{t.promotions_page.eyebrow}</p>
            <h1 className="mt-6 font-serif text-6xl md:text-8xl font-light tracking-tight leading-[0.95]">
              {t.promotions_page.title}
            </h1>
          </div>
          <div className="md:col-span-5 md:pl-8">
            <p className="text-ink/75 font-light text-lg leading-relaxed max-w-md">{t.promotions_page.lede}</p>
          </div>
        </div>
      </section>

      {/* GRID */}
      <section className="pb-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-6">
          {promotions.map((p, i) => {
            const d = p[lang];
            const isDark = i % 3 === 0 || i % 3 === 2;
            return (
              <article
                key={p.key}
                data-testid={`promo-${p.key}`}
                className={`relative p-10 md:p-12 border border-ink/20 overflow-hidden flex flex-col justify-between min-h-[320px] ${
                  isDark ? "bg-ink text-cream" : "bg-cream-light text-ink"
                }`}
              >
                <div>
                  <div className="flex items-start justify-between gap-6">
                    <p className={`overline ${isDark ? "text-cream/60" : "text-ink/60"}`}>{d.tag}</p>
                    <span
                      className={`font-serif text-4xl md:text-5xl font-light italic ${
                        isDark ? "text-cream" : "text-ink"
                      }`}
                    >
                      {p.badge}
                    </span>
                  </div>
                  <h3 className="mt-6 font-serif text-3xl md:text-4xl font-light leading-tight max-w-[20ch]">
                    {d.title}
                  </h3>
                  <p className={`mt-5 font-light leading-relaxed max-w-md ${isDark ? "text-cream/80" : "text-ink/75"}`}>
                    {d.desc}
                  </p>
                </div>
                <a
                  href={buildWhatsAppUrl("promotion", lang, d.title)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`promo-cta-${p.key}`}
                  className={`mt-8 self-start inline-flex items-center gap-2 px-5 py-3 text-xs tracking-[0.22em] uppercase btn-sweep border ${
                    isDark ? "border-cream text-cream hover:text-ink sweep-cream" : "border-ink text-ink hover:text-cream sweep-ink"
                  }`}
                >
                  {d.cta} →
                </a>
              </article>
            );
          })}
        </div>
      </section>

      {/* TERMS */}
      <section className="pb-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <p className="text-ink/55 text-xs font-light max-w-3xl">* {t.promotions_page.terms}</p>
        </div>
      </section>
    </main>
  );
};

export default Promociones;
